import { render, staticRenderFns } from "./ToolsIcon.vue?vue&type=template&id=48c604fd&"
import script from "./ToolsIcon.vue?vue&type=script&lang=js&"
export * from "./ToolsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports